import { RouteComponentProps } from "@reach/router"
import { Layout } from "../../components/Layout";

export const Services: React.FC<RouteComponentProps> = () => (
    <Layout>Services page</Layout>
);